import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';

const DeleteCampaignModal = ({ isOpen, onClose, campaign, onConfirm, isLoading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirmar Eliminación</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Alert status="warning">
              <AlertIcon />
              Esta acción desactivará la campaña pero mantendrá todos los datos históricos.
            </Alert>
            
            <Text>
              ¿Está seguro de que desea eliminar la campaña:
            </Text>
            <Text fontWeight="bold" color="blue.500">
              {campaign?.code} - {campaign?.description}
            </Text>
            
            {campaign?.chassisCount > 0 && (
              <Text fontSize="sm" color="gray.600">
                Esta campaña tiene {campaign.chassisCount} números de chasis asociados.
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button 
            colorScheme="red" 
            onClick={() => onConfirm(campaign.id)}
            isLoading={isLoading}
          >
            Eliminar Campaña
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteCampaignModal;
